import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createInput,
  createRequirement,
  formData,
  setFormData,
  getRequirementList,
  history,
  showRequirement,
  getMenuList,
  menuList,
  createRichTextEditor,
  draftToHtml,
  convertToRaw
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    
    const payload = {
      ...formData,
      description_en: draftToHtml(convertToRaw(_.get(formData, 'description_en').getCurrentContent())),
      description_tl: draftToHtml(convertToRaw(_.get(formData, 'description_tl').getCurrentContent()))
    }
    
    createRequirement(payload, ({ data }) => {
      setModal({ isOpen: false });
      getRequirementList();
      history.push(`/general-settings/how-to/sub/${_.get(data, 'id')}`);
      showRequirement(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    getMenuList();
  }, []);

  const handleDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectMenuList = menuList.map(x => ({
    label: _.get(x, 'attributes.title_en'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <Select
              options={selectMenuList}
              placeholder="Select Menu"
              onChange={handleDropDownChange('how_tos_menu_id')}
            />
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'title_en', label: 'Title English:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'title_tl', label: 'Title Filipino:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'sequence', label: 'Sequence:' },
              { required: true, minLength: 3, type: 'number' }
            )}
          </div>
          <div className="col-12 form-group">
            {createRichTextEditor(
              { key: 'description_en', label: 'Description English:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createRichTextEditor(
              { key: 'description_tl', label: 'Description Filipino:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  createRequirement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
  getMenuList: PropTypes.instanceOf(Function).isRequired,
  menuList: PropTypes.instanceOf(Array).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  menuList: _.get(api, `${c.GET_MENU_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
